﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSV = void 0;
const GUIController_1 = require("./appControllers/GUIController");
const StateDashboard_1 = require("./states/StateDashboard");
const gs_1 = require("@ivanlog/gs");
const StateApp_1 = require("./states/abstracts/StateApp");
const StateLoading_1 = require("./states/StateLoading");
const DesignThemeEnum_1 = require("./enums/DesignThemeEnum");
const Web3Controller_1 = require("./appControllers/Web3Controller");
class AppSV {
    constructor() {
        AppSV.Inst = this;
        StateApp_1.StateUp.App = this;
        gs_1.StateGS.DefaultStateName = 'loading';
        this.gui = new GUIController_1.GUIController(this);
        this.chain = new Web3Controller_1.Web3Controller(this);
        this.gui.setTheme(DesignThemeEnum_1.DesignThemeEnum.LightGrey);
        this.start();
    }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            gs_1.StateGS.RegState(StateLoading_1.StateLoading);
            gs_1.StateGS.RegState(StateDashboard_1.StateDashboard);
            gs_1.StateGS.DefaultStateName = StateDashboard_1.StateDashboard.StateName;
            yield gs_1.StateGS.Run(StateLoading_1.StateLoading);
            yield this.chain.start();
            if (this.chain.isConnected) {
                yield gs_1.StateGS.Run(StateDashboard_1.StateDashboard);
                // const byUrl = await StateGS.RunByUrl()
                // if (byUrl === StateRunResultEnum.Failed) 
            }
            else {
                yield gs_1.StateGS.Run(StateLoading_1.StateLoading);
            }
        });
    }
    awaitTime(timeMS) {
        return new Promise((resolve, reject) => {
            setTimeout(() => resolve(), timeMS);
        });
    }
}
exports.AppSV = AppSV;
AppSV.ADDRESS_SmarVaultManager = "0x0DC17bc79d48319401dA3100B8c127b0F06C4338";
AppSV.ADDRESS_PriceKeeperPLS = "0x266D108Ea2bDeFEcC3b044acaf2BDC99825fB354";
AppSV.ADDRESS_LLVaultManager = "0xEf3B5738C770dc90773DaDD1d5f9b8FbeA458be8";
AppSV.ADDRESS_USDL_ERC20 = "0x6f463B77190bce5D4a9fa65DfB858D8597d4E3f1";
AppSV.ADDRESS_DIFF_CALC = "0x52c4e3aaF6181bB6022b879F0449b02Ae7Bc60E3";
//public static CHAIN_RPC:string="https://rpc.pulsechain.com"
AppSV.CHAIN_RPC = "https://rpc.v4.testnet.pulsechain.com";
AppSV.version = "0.0.1";
//# sourceMappingURL=AppSV.js.map